export function flattenObject(
  obj: unknown,
  parentKey = "",
): Record<string, unknown> {
  if (typeof obj !== "object" || obj === null) {
    return {};
  }

  return Object.entries(obj).reduce((acc, [key, value]) => {
    const fullKey = parentKey ? `${parentKey}.${key}` : key;
    if (
      typeof value === "object"
        && value !== null
        && !Array.isArray(value)
    ) {
      Object.assign(acc, flattenObject(value, fullKey));
    } else {
      acc[fullKey] = value;
    }

    return acc;
  }, {} as Record<string, unknown>);
}
